import { render, staticRenderFns } from "./shopSales-temp.vue?vue&type=template&id=610d39da&scoped=true&"
var script = {}
import style0 from "./shopSales-temp.vue?vue&type=style&index=0&id=610d39da&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610d39da",
  null
  
)

export default component.exports